import React, {ReactNode} from "react";
import { FrontWebSongModel} from "../../../generated";
import SongCss from "../Style.module.scss";
import { RouteLink } from "../../RouteLink";

import {useLyrics} from "../../../contexts/useLyrics";

export const LyricsLink = (props: {
    className?: string
    children: ReactNode
    song: FrontWebSongModel
}) => {
    const callback = useLyrics()

    if (!props.song.lyricsRadioSlug)
        return <>{props.children}</> ?? null;

    return <>
        <RouteLink onClick={e=>{
            e.preventDefault();
            const slug = props.song.lyricsRadioSlug;
            callback(slug!, props.song.id);
        }} to={"#"} className={`d-flex ${SongCss.LinkRow} flex-row ${props.className ?? ""}`}>
            {props.children}
        </RouteLink>
    </>
}